import { subscriptionBadgeSizeToPx } from '../logoBadgeSizeToPx';
import { SubscriptionBadgeBadgeProps } from '../types';
import plusIconSrc from './plus-icon.svg';
import plusIconCircleSrc from './plus-icon-circle.svg';
import plusFullLightTextSrc from './plus-full-light-text.svg';
import plusFullDarkTextSrc from './plus-full-dark-text.svg';

const getSvgSrc = ({ variant, textColor }: SubscriptionBadgeBadgeProps) => {
  switch (variant) {
    case 'icon':
      return plusIconSrc;
    case 'icon-circle':
      return plusIconCircleSrc;
    case 'full':
      if (textColor === 'light') {
        return plusFullLightTextSrc;
      }
      return plusFullDarkTextSrc;
    default:
      return plusFullDarkTextSrc;
  }
};

const PlusLogoBadge = ({ className, size = 'md', variant, textColor }: SubscriptionBadgeBadgeProps) => {
  // TODO: Placeholder ticket to determine if alt text is needed https://alltrails.atlassian.net/browse/GROW-10485

  // In mugen, next/image automatically calculates the width of the image based on the height and the aspect ratio.
  // We need to do this manually for the regular img tag.
  const fullVariantAspectRatio = 2.292;
  const aspectRatio = variant === 'full' ? fullVariantAspectRatio : 1;
  const width = subscriptionBadgeSizeToPx[size] * aspectRatio;

  return (
    <img
      className={className}
      src={getSvgSrc({ variant, textColor })}
      height={subscriptionBadgeSizeToPx[size]}
      width={width}
      title="Plus"
      alt="Plus"
    />
  );
};

export default PlusLogoBadge;
